import React from "react";
import { useLang } from "../context/LanguageContext";
import { venueImages } from "../lib/i18n";
import { useImages } from "../hooks/useImages";

const About = () => {
  const { t } = useLang();
  const { one } = useImages();
  const aboutSrc = one("about", venueImages.coffee);
  return (
    <section
      data-testid="about-section"
      className="relative py-24 lg:py-32 bg-[color:var(--ivory-2)]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 lg:gap-12">
          <div className="col-span-12 md:col-span-5 lg:col-span-4">
            <p className="overline text-[color:var(--wine)] flex items-center">
              <span className="section-line"></span>
              {t.about.eyebrow}
            </p>
            <h2 className="mt-6 font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              {t.about.title}
            </h2>
          </div>

          <div className="col-span-12 md:col-span-7 lg:col-span-5 md:pt-4 space-y-6">
            <p className="text-lg leading-relaxed text-[color:var(--ink-2)]">
              {t.about.body_1}
            </p>
            <p className="text-lg leading-relaxed text-[color:var(--ink-2)]">
              {t.about.body_2}
            </p>
            <div className="grid grid-cols-3 gap-4 pt-8 border-t border-[color:var(--wine)]/30">
              {t.about.stats.map((s, i) => (
                <div key={i} data-testid={`about-stat-${i}`}>
                  <div className="font-serif-display text-3xl lg:text-4xl text-[color:var(--wine)]">{s.value}</div>
                  <div className="overline mt-2 text-[color:var(--ink-3)] text-[0.65rem]">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:block col-span-3">
            <div className="aspect-[3/4] overflow-hidden group">
              <img
                src={aboutSrc}
                alt="Cappuccino – Caffè Sorriso"
                className="w-full h-full object-cover smooth-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
